module.exports = __webpack_public_path__ + "img/DealerIcons-YouTube-Off.00fdd88.jpg";